import React from 'react';

interface VinData {
  vin?: string | null;
  make?: string | null;
  model?: string | null;
  year?: number | string | null;
}

interface VinDetailHeaderActionsProps {
  data?: VinData;
  loading: boolean;
  error: string | null;
}

function VinDetailHeaderActions({ data, loading, error }: VinDetailHeaderActionsProps) {
  const vin = data?.vin || '';
  const make = data?.make || '';
  const model = data?.model || '';
  const year = data?.year || '';

  if (error && !loading) {
    return null;
  }

  return (
    <div className="flex items-center">
      <div className="w-[1px] h-6 bg-gray-300 mx-4"></div>
      <div className="flex items-center space-x-3">
        <div className="flex items-center space-x-2">
          <div className="text-gray-400 text-sm">VIN /</div>
          <span className="text-gray-750 font-bold">{vin}</span>
          {!loading && (
            <>
              <div className="">|</div>
              <span className="text-gray-600 text-md">{make}</span>
              <div className="">|</div>
              <span className="text-gray-600 text-md">{model}</span>
              <div className="">|</div>
              <span className="text-gray-600 text-md">{year}</span>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default VinDetailHeaderActions;
